<template>
  <div class="font-options">
    <div class="type">
      <div class="option">
        <input type="radio" id="type-all" value="all" v-model="type">
        <label for="type-all">All</label>
      </div>
      <div class="option">
        <input type="radio" id="type-serif" value="serif" v-model="type">
        <label for="type-serif">Serif</label>
      </div>
      <div class="option">
        <input type="radio" id="type-sans-serif" value="sans-serif" v-model="type">
        <label for="type-sans-serif">Sans Serif</label>
      </div>
      <div class="option">
        <input type="radio" id="type-other" value="other" v-model="type">
        <label for="type-other">Other</label>
      </div>
    </div>
    <div class="weight">
      <div class="option">
        <input type="radio" id="weight-all" value="all" v-model="weight">
        <label for="weight-all">All</label>
      </div>
      <div class="option">
        <input type="radio" id="weight-light" value="light" v-model="weight">
        <label for="weight-light">Light</label>
      </div>
      <div class="option">
        <input type="radio" id="weight-regular" value="regular" v-model="weight">
        <label for="weight-regular">Regular</label>
      </div>
      <div class="option">
        <input type="radio" id="weight-bold" value="bold" v-model="weight">
        <label for="weight-bold">Bold</label>
      </div>  
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'font-options',
    computed: {
      ...mapState('font', [
        'filters',
      ]),
      type: {
        get() {
          return this.filters.type;
        },
        set(value) {
          this.setFilters({
            type: value,
            weight: this.weight
          });
        }
      },
      weight: {
        get() {
          return this.filters.weight;
        },
        set(value) {
          this.setFilters({
            type: this.type,
            weight: value
          });
        }
      },
    },
    methods: {
      ...mapActions('font', [
        'setFilters'
      ]),
    }
  }
</script>

<style lang="scss" scoped>
  label {
    font-size: 0.875rem;
    opacity: 0.45;
    cursor: pointer;
    transition: opacity 250ms;

    .app.dark & {
      color: #fff;
    }
  }

  input {
    display: none;

    &:checked + label {
      opacity: 1;
    }
  }

  .option {
    margin-bottom: 0.25rem;
  }
  
  .weight {
    margin-top: 1rem;
  }
</style>